function trunc(num: number, positions: number): number {
  return Math.round(num * Math.pow(10, positions)) / Math.pow(10, positions);
}

function checkLicense(
  licenses: any,
  term: any,
  nodes: any,
  update: boolean,
  licenseID?: number
): boolean {
  const licensesByNodes = [];
  let checked = true;

  for (let index = 0; index < licenses.length; index++) {
    if (licenses[index].licenseEquipments == nodes) {
      licensesByNodes.push(licenses[index]);
    }
  }

  if (licensesByNodes.length == 0) {
    return checked;
  } else {
    if (update) {
      for (let indexTerm = 0; indexTerm < licensesByNodes.length; indexTerm++) {
        if (
          licensesByNodes[indexTerm].licenseTerm == term &&
          licensesByNodes[indexTerm].licenseID !== licenseID
        ) {
          checked = false;
        }
      }
    } else {
      for (let index = 0; index < licensesByNodes.length; index++) {
        if (licensesByNodes[index].licenseTerm == term) {
          checked = false;
        }
      }
    }
    return checked;
  }
}

function formatPrice(value: any): string {
  const val = (value / 1).toFixed(2).replace(".", ",");
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export { trunc, checkLicense, formatPrice };
